<template>
    <base-dashboard-view class="tools">
        <h2>{{ siteTitle }}</h2>
        <template v-if="user.pro && licenses">
            <template v-for="license in licenses">
                <pro-message-box :key="license.key" :license="license">
                    <template v-slot:box-text>
                        You now have access to the full suite of product features.
                        <template v-if="license.free_seats > 0 ">
                            <span>Use the key below to activate the license on your WordPress site. Need to use Fusebox on more than {{ license.seats }} website? Add additional sites here and use the same license key on each.</span>
                        </template>
                        <template v-else>
                            <span>Looks like you don’t have more sites available in your plan.</span>
                        </template>
                    </template>
                </pro-message-box>
            </template>
        </template>
        <message-box v-if="!user.pro" />
        <transition
            name="fade"
            mode="out-in"
        >
            <div
                v-if="groupedProductFeatures"
                :key="'content'"
                class="content"
            >
                 <template v-for="( product, index ) in products">
                     <div
                        :key="product.id"
                        class="content-box"
                    >
                        <tools-product
                            :product="product"
                            :index="index"
                            :grouped-features="groupedProductFeatures"
                        />
                        <video-section
                            :videos="product.video_list"
                            :support-link="product.kb_link"
                        />
                     </div>
                 </template>
            </div>
            <div
                v-else
                :key="'loader'"
                class="loader"
            >
                <i class="fas fa-spinner fa-spin loader" />
            </div>
        </transition>
    </base-dashboard-view>
</template>

<script>
import dashboardTitle from '@/mixins/dashboardTitle';
import ProMessageBox from '@/components/ProMessageBox';
import MessageBox from '@/components/Tools/MessageBox';
import ToolsProduct from '@/components/Tools/ToolsProduct';
import VideoSection from '@/components/Tools/VideoSection';

import { mapState, mapGetters } from 'vuex';

export default {
    components: {
        ProMessageBox,
        MessageBox,
        ToolsProduct,
        VideoSection,
    },

    mixins: [dashboardTitle],

    computed: {
        ...mapState([
            'user',
            'licenses',
            'products',
        ]),
        ...mapGetters(['groupedProductFeatures']),
    },
};
</script>
